import React from 'react';
import Immutable from 'immutable';

import {
	styled,
	ParentBoundComponent,
	Module,
	TabPane,
	NumberUtils,
	webapi,
	REPORTED_EXCEPTION,
	Button,
	updateEntityTimestamp,
	FlexBox,
	FlexBoxBlock,
	showMessageBox,
} from 'ps-gui';

import {
	CellError,
	CellMainText,
	CellSubText
} from '../portalresultsetmodule';


import {
	ModuleBodySection,
	ModuleHeaderSection,
	ModuleHeader,
	ModuleHeaderBlock
} from '../../blocks/modulesections';

import AffirmationSubmissionAdminModel from './affirmationsubmissionadminmodel';
import { getFormItemLabel, getPhrase } from '../../data/phrases';
import { exportToExcel, getGlobalContextChangeChecker } from '../utils';

import { ReactComponent as ModuleLogo } from '../../svg/submission.svg';
import { GlobalContext, withGlobalContext } from '../../data/globalcontext';

import {StatusBubble} from '../submissioncomponents';
import { getLookup } from '../../data/lookup';
import { renderDateTimeCell } from '../commoncellrenderers';
import { Bubble } from './correctioninput';


const Wrapper = styled.div`
	z-index: 0;
	.ps-moduleContainerContent {
		overflow: visible !important;
	}

	.ps-tabPaneContent {
		overflow: visible !important;
		padding-top: 24px;
	}

	.ps-moduleContainerToolbar {
		background: rgb(251, 251, 251);
		position: sticky;
		top: 0px;
		z-index: 1;
		align-items: baseline;
	}
`;

const RowCountEtc = styled.div`
	margin-bottom: 24px;
`;

const RowCount = styled.div`
	display: inline-block;
	color: ${props => props.theme.disabledTextColor};
	font-size: 20px;
	margin-right: 40px;
	.label {
		font-weight: 400;
		margin-right: 5px;
	}
	.value {
		font-weight: 900;
	}
`;


class AffirmationSubmissionAdminModule extends ParentBoundComponent {

	constructor() {
		super();
		this.setRoleId = this.setRoleId.bind(this);
		this.setDistributionPeriodId = this.setDistributionPeriodId.bind(this);
		this.checkGlobalContextChange = getGlobalContextChangeChecker(this);
		this.onTabSelected = this.onTabSelected.bind(this);
		this.conflictCustomResultProps = getConflictCustomResultProps(this);
		this.anomalyCustomResultProps = getAnomalyCustomResultProps(this);
		this.customResultProps = getCustomResultProps(this);
	}

	onTabSelected(tabId) {
		this.setModel(this.getModel().setSelectedTabId(tabId));
	}

	getModel() {
		return new AffirmationSubmissionAdminModel(this.getData());
	}

	setConflictIsPublic(id, isPublic) {
		this.setModel(this.getModel().setConflictIsPublic(id, isPublic));
	}

	setAnomalyAdminComments(id, value) {
		this.setModel(this.getModel().setAnomalyAdminComments(id, value));
	}

	setConflictAdminComments(id, value) {
		this.setModel(this.getModel().setConflictAdminComments(id, value));
	}

	setSubmissionAdminComments(id, value) {
		this.setModel(this.getModel().setSubmissionAdminComments(id, value));
	}

	async setRoleId(value) {
		let model = this.getModel().setRoleId(value);
		this.setModel(await model.loadData());
	}

	async setDistributionPeriodId(value) {
		let model = this.getModel().setDistributionPeriodId(value);
		this.setModel(await model.loadData());
	}

	setModel(model) {
		this.setData(model.getData());
	}

	componentDidMount() {
		this.checkGlobalContextChange();
	}

	componentDidUpdate(prevProps) {
		this.checkGlobalContextChange(prevProps);
	}

	renderSubmissionList() {
		const data = this.getData();
		const model = this.getModel();
		return (
			<>
				{
					!model.isDetailOpen() && (
						<FlexBox>
							<FlexBoxBlock flexGrow='1'>
								<RowCount>
									<span className="label">{getPhrase('submissionCount')}:</span>
									<span className="value">{data.getIn([
										'esad',
										'data',
										'search',
										'data',
										'result',
										'data',
										'pager',
										'totalCount'
									])}</span>
								</RowCount>
							</FlexBoxBlock>
							<FlexBoxBlock>
								<Button
									margin='0px'
									type='medium'
									text={getPhrase('exportAllCompletedSubmissionsToExcel')}
									onAction={async () => {
										const distributionPeriodId = data.getIn([
											'esad',
											'data',
											'search',
											'data',
											'customFilter',
											'distribution_period'
										]);
										if (!distributionPeriodId) {
											await showMessageBox('Vyberte nejdříve distribuční období.');
											return;
										}
										const res = await webapi.execute('/api/proc/api_affirmations/getMissingCurrencies', {
											distributionPeriodId
										});
										if (res === REPORTED_EXCEPTION) {
											return;
										}
										if (res.length > 0) {
											await showMessageBox(getPhrase(res.length > 1 ? 'cannotExportThereAreMissingExchangeRates' : 'cannotExportThereAreMissingExchangeRate').replace('$currencies', res.join(', ')));
											return;
										}
										const fileName = 'Podání ČP VZOZ - ' + distributionPeriodId + '.xlsx';
										exportToExcel('API_AffirmationAdminFullExcelExport', {distributionPeriodId}, fileName);

									}}
								/>
							</FlexBoxBlock>
						</FlexBox>
					)
				}
				<RowCountEtc>
				</RowCountEtc>
				<Module
					appState={data.get('esad')}
					onDataChange={newData => {
						this.setData(data.setIn(['esad', 'data'], newData));
					}}
					customResultProps={this.customResultProps}
				/>
			</>
		);
	}

	renderAnomalies() {
		const data = this.getData();
		const distributionPeriodId = data.getIn([
			'anomalies',
			'data',
			'customFilter',
			'distribution_period_id'
		]);
		return (
			<>
				<ConflictButtons>
					{
						distributionPeriodId ? (
							<>
								<Button
									type='medium'
									text={getPhrase('exportAnomaliesForDistributionPeriod').replace('$distributionPeriodId', distributionPeriodId)}
									onAction={async () => {
										exportToExcel('API_AffirmationAdminAnomalyExcelExport', {
											distributionPeriodId
										}, 'Anomalie ' + distributionPeriodId + '.xlsx');
									}}
								/>
							</>
						) : (
							<span className='message'>Vyberte distribuční období</span>
						)
					}
				</ConflictButtons>
				<Module
					key='anomalies'
					appState={data.get('anomalies')}
					onDataChange={newData => {
						this.setData(data.setIn(['anomalies', 'data'], newData));
					}}
					customResultProps={this.anomalyCustomResultProps}
				/>
			</>
		);
	}

	renderProducerSummary() {
		const data = this.getData();
		return (
			<>
				<FlexBox>
					<FlexBoxBlock flexGrow="1"></FlexBoxBlock>
					<FlexBoxBlock>
						<Button
							margin='0px 0px 16px 0px'
							type='medium'
							text={getPhrase('exportToExcel')}
							onAction={async () => {
								const distributionPeriodId = data.getIn([
									'producerSummary',
									'data',
									'customFilter',
									'distribution_period_id'
								]);
								if (!distributionPeriodId) {
									await showMessageBox('Vyberte nejdříve distribuční období.');
									return;
								}
								const res = await webapi.execute('/api/proc/api_affirmations/getMissingCurrencies', {
									distributionPeriodId
								});
								if (res === REPORTED_EXCEPTION) {
									return;
								}
								if (res.length > 0) {
									await showMessageBox(getPhrase(res.length > 1 ? 'cannotExportThereAreMissingExchangeRates' : 'cannotExportThereAreMissingExchangeRate').replace('$currencies', res.join(', ')));
									return;
								}
								const fileName = 'Přehled výrobců ČP VZOZ - ' + distributionPeriodId + '.xlsx';
								exportToExcel('API_AffirmationProducerSummaryExcelExport', {distributionPeriodId}, fileName);

							}}
						/>
					</FlexBoxBlock>
				</FlexBox>
				<Module
					key='producerSummary'
					appState={data.get('producerSummary')}
					onDataChange={newData => {
						this.setData(data.setIn(['producerSummary', 'data'], newData));
					}}
					customResultProps={producerSummaryCustomResultProps}
				/>
			</>
		);
	}

	renderCurrencies() {
		const data = this.getData();
		return (
			<>
				<Module
					key='currencies'
					appState={data.get('currencies')}
					onDataChange={newData => {
						this.setData(data.setIn(['currencies', 'data'], newData));
					}}
				/>
			</>
		);
	}

	renderConflicts() {
		const data = this.getData();
		const distributionPeriodId = data.getIn([
			'conflicts',
			'data',
			'customFilter',
			'distribution_period_id'
		]);
		return (
			<>
				<ConflictButtons>
					{
						distributionPeriodId ? (
							<>
								<Button
									type='medium'
									text={getPhrase('exportConflictsForDistributionPeriod').replace('$distributionPeriodId', distributionPeriodId)}
									onAction={async () => {
										exportToExcel('API_AffirmationAdminConflictExcelExport', {
											distributionPeriodId
										}, 'Konflikty ' + distributionPeriodId + '.xlsx');
									}}
								/>
								<Button
									type='medium'
									text={getPhrase('refreshConflictsForDistributionPeriod').replace('$distributionPeriodId', distributionPeriodId)}
									onAction={async () => {
										console.log(distributionPeriodId);
										await webapi.execute('/api/proc/api_affirmations/refreshConflicts', {
											distributionPeriodId
										});
										updateEntityTimestamp('affirmationSubmissionConflict');
									}}
								/>
							</>
						) : (
							<span className='message'>Vyberte distribuční období</span>
						)
					}
				</ConflictButtons>
				<Module
					key='conflicts'
					appState={data.get('conflicts')}
					onDataChange={newData => {
						this.setData(data.setIn(['conflicts', 'data'], newData));
					}}
					customResultProps={this.conflictCustomResultProps}
				/>
			</>
		);
	}

	render() {
		const data = this.getData();
		const selectedTabId = data.get('selectedTabId') || 'submissionList';
		return (
			<Wrapper>
				<ModuleHeaderSection className="noBorder">
					<ModuleHeaderBlock>
						<ModuleHeader>{getPhrase('AffirmationSubmission')}</ModuleHeader>
					</ModuleHeaderBlock>
					<ModuleHeaderBlock>
						<ModuleLogo />
					</ModuleHeaderBlock>
				</ModuleHeaderSection>
				<ModuleBodySection top="-16px">
					<TabPane
						selectedTabId={selectedTabId}
						tabs={tabs}
						onTabSelected={this.onTabSelected}
					>
					</TabPane>
					{
						selectedTabId === 'submissionList' ? this.renderSubmissionList() :
							selectedTabId === 'anomalies' ? this.renderAnomalies() :
								selectedTabId === 'conflicts' ? this.renderConflicts() :
									selectedTabId === 'producerSummary' ? this.renderProducerSummary() : this.renderCurrencies()
					}
				</ModuleBodySection>
			</Wrapper>
		);
	}
}

const ConflictButtons = styled.div`
	text-align: right;
	margin-bottom: 8px;
	.message {
		font-weight: 500;
	}
`;

const cellRendererMap = Object.freeze({
	'party_id': (cell, row, colIndex) => {
		return (
			<>
				<CellMainText className="secondary">{cell}</CellMainText>
				<CellSubText>{row.get('party_id')} - {row.get('role_type')}</CellSubText>
			</>
		);
	},
	'distribution_period': (cell, row, colIndex) => {
		return (
			<CellMainText>{cell}</CellMainText>
		);
	},
	'created_when': (cell, row, colIndex) => {
		return (
			<>
				<CellMainText>{cell}</CellMainText>
				<CellSubText>{row.get('created_by')}</CellSubText>
			</>
		);
	},
	'status': (cell, row) => {
		return (
			<StatusBubble className={row.get('status_id')}>{cell}</StatusBubble>
		);
	},
	'edited_when': renderDateTimeCell,
	'last_submitted': renderDateTimeCell,
});

const DetailItem = styled.div`
	.id {
		opacity: 0.7;
		font-size: 80%;
		font-weight: 500;
	}
	.year {
		font-weight: 500;
		margin-right: 4px;
	}

	.name {
		margin-left: 4px;
	}

	.amount {
		font-weight: 500;
		margin-right: 4px;
		&:not(:first-child) {
			margin-left: 4px;
		}
	}
	.currency {
		font-weight: 500;
		opacity: 0.7;
		margin-right: 4px;
	}
	.share {
		min-width: 60px;
		font-weight: 500;
		margin-right: 4px;
		display: inline-block;
		text-align: right;
	}

	.attendance {
		font-weight: 500;
		margin-right: 4px;
		display: inline-block;
		text-align: right;
	}

	.broadcast_count {
		font-weight: 500;
		opacity: 0.7;
	}
	.runtime {
		font-weight: 500;
		margin-right: 4px;
		display: inline-block;
	}
`;

const Title = styled.div`
	.year {
		opacity: 0.7;
		font-size: 80%;
		font-weight: 500;
	}
`;

function getCustomResultProps(module) {
	return {
		cellRendererMap: {
			'party_id': (cell, row, colIndex) => {
				return (
					<>
						<CellMainText className="secondary">{cell}</CellMainText>
						<CellSubText>{row.get('party_id')}</CellSubText>
					</>
				);
			},
			admin_comments: (cell, row) => {
				return (
					<Bubble
						value={row.get('admin_comments')}
						onMouseDown={async () => {
							const value = await showMessageBox(getFormItemLabel('adminComments'), {
								type: 'input',
								multiline: true,
								optional: true,
								input: row.get('admin_comments')
							});
							if (value === null) {
								return;
							}
							const distributionPeriodId = row.get('distribution_period_id');
							const partyId = row.get('party_id');
							const roleTypeId = row.get('role_type_id');
							const res = await webapi.execute('/api/proc/api_affirmations/setSubmissionAdminComments', {
								distributionPeriodId,
								partyId,
								roleTypeId,
								adminComments: value
							});
							if (res === REPORTED_EXCEPTION) {
								return;
							}
							module.setSubmissionAdminComments(row.get('id'), value);
						}}
						text={getPhrase('comment')}
					/>
				);
			},
			'distribution_period': (cell, row, colIndex) => {
				return (
					<CellMainText>{cell}</CellMainText>
				);
			},
			'created_when': (cell, row, colIndex) => {
				return (
					<>
						<CellMainText>{cell}</CellMainText>
						<CellSubText>{row.get('created_by')}</CellSubText>
					</>
				);
			},
			'status': (cell, row) => {
				return (
					<StatusBubble className={row.get('status_id')}>{cell}</StatusBubble>
				);
			},
			'edited_when': renderDateTimeCell,
			'last_submitted': renderDateTimeCell,
		},
		withNewEntityButton: false,
		withRowSelection: true,
		defaultColumnWidths: {
			'country': '100px',
			'attendance': '110px',
			'status': '180px',
			'release_date': '110px',
			'cinema_attendance_record_count': '120px',
			'broadcast_record_count': '120px',
			'sale_record_count': '120px',
			distribution_period: '120px',
			correction: '130px',
			imported_from_excel: '140px',
			edited_when: '120px',
			last_submitted: '120px',
			admin_comments: '120px',
		},
		columnAlign: {
			'cinema_attendance_record_count': 'right',
			'broadcast_record_count': 'right',
			'sale_record_count': 'right',
			'admin_comments': 'center'
		},
		columnFilters: {
			'distribution_period': {
				type: 'lookup',
				lookup: 'affirmationDistributionPeriod'
			},
			correction: {
				type: 'lookup',
				lookup: 'ynBoolean'
			},
			imported_from_excel: {
				type: 'lookup',
				lookup: 'ynBoolean'
			},
			status: {
				type: 'lookup',
				lookup: 'submissionStatus'
			},
			party_id: {
				type: 'lookup',
				lookup: 'affirmationSubmissionParty'
			},
			cinema_attendance_record_count: {
				type: 'number'
			},
			broadcast_record_count: {
				type: 'number'
			},
			sale_record_count: {
				type: 'number'
			},
			edited_when: {
				type: 'date'
			},
			last_submitted: {
				type: 'date'
			},
			admin_comments: {
				type: 'lookup',
				lookup: 'ynBoolean',
				filterName: 'has_admin_comments'
			}
		}
	};
}

let affirmationSubmissionItemTypeLookup = null;

const producerSummaryCustomResultProps = {
	cellRendererMap: {
		producer: (cell, row) => {
			return (
				<>
					<CellMainText>{cell}</CellMainText>
					<CellSubText>{row.get('party_id')}</CellSubText>
				</>
			);
		},
		total_physical_sale_income: (cell, row) => {
			const mc = row.get('missing_currencies_physical');
			if (!mc) {
				return cell;
			}
			return (
				<>
					<span>{cell}</span>
					<CellError>{getPhrase('missingExchangeRates')}: {mc}</CellError>
				</>
			);
		},
		total_digital_sale_income: (cell, row) => {
			const mc = row.get('missing_currencies_digital');
			if (!mc) {
				return cell;
			}
			return (
				<>
					<span>{cell}</span>
					<CellError>{getPhrase('missingExchangeRates')}: {mc}</CellError>
				</>
			);
		},
	},
	withNewEntityButton: false,
	defaultColumnWidths: {
		total_attendance: '160px',
		total_runtime: '160px',
		total_physical_sale_income: '160px',
		total_digital_sale_income: '160px',
		'distribution_period_id': '210px',
	},
	columnAlign: {
		total_attendance: 'right',
		total_runtime: 'right',
		total_physical_sale_income: 'right',
		total_digital_sale_income: 'right',
	},
	columnFilters: {
		'distribution_period_id': {
			type: 'lookup',
			lookup: 'affirmationDistributionPeriod'
		},
		type: {
			type: 'lookup',
			lookup: 'affirmationAnomaly'
		},
		total_runtime: {
			type: 'number'
		},
		total_physical_sale_income: {
			type: 'number'
		},
		total_digital_sale_income: {
			type: 'number'
		},
		total_attendance: {
			type: 'number'
		},
		producer: {
			type: 'lookup',
			lookup: 'affirmationSubmissionParty'
		}
	}
};

function getAnomalyCustomResultProps(module) {
	return {
		cellRendererMap: {
			type: (cell, row) => {
				return getPhrase(cell);
			},
			title: (cell, row) => {
				const productionYear = row.get('production_year');
				return (
					<Title>
						{cell} <span className='year'>({productionYear})</span>
					</Title>
				);
			},
			admin_comments: (cell, row) => {
				return (
					<Bubble
						value={row.get('admin_comments')}
						onMouseDown={async () => {
							const value = await showMessageBox(getFormItemLabel('adminComments'), {
								type: 'input',
								multiline: true,
								optional: true,
								input: row.get('admin_comments')
							});
							if (value === null) {
								return;
							}
							const res = await webapi.execute('/api/proc/api_affirmations/setAnomalyAdminComments', {
								id: row.get('id'),
								adminComments: value
							});
							if (res === REPORTED_EXCEPTION) {
								return;
							}
							module.setAnomalyAdminComments(row.get('id'), value);
						}}
						text={getPhrase('comment')}
					/>
				);
			},
			detail: (cell, row) => {
				if (!cell) {
					return '';
				}
				const type = row.get('type');
				if (type === 'productionYearMismatch') {
					return cell.map((item, index) => {
						return (
							<DetailItem key={index}>
								<span className='year'>{item.get('productionYear')}</span>
								-
								<span className='name'>{item.get('partyName')} <span className='id'>({item.get('partyId')})</span></span>
							</DetailItem>
						);
					});
				} else if (type === 'attendanceMismatch') {
					return cell.map((item, index) => {
						return (
							<DetailItem key={index}>
								<span className='attendance'>{NumberUtils.formatNumber(item.get('attendance'))}</span>
								-
								<span className='name'>{item.get('partyName')} <span className='id'>({item.get('partyId')})</span></span>
							</DetailItem>
						);
					});
				} else if (type === 'runtimeMismatch') {
					return cell.map((item, index) => {
						return (
							<DetailItem key={index}>
								<span className='broadcast_count'>{item.get('count')} x </span><span className='runtime'>{NumberUtils.formatNumber(item.get('runtime'))}</span>
								-
								<span className='name'>{item.get('partyName')} <span className='id'>({item.get('partyId')})</span></span>
							</DetailItem>
						);
					});
				} else {
					return cell.map((item, index) => {
						return (
							<DetailItem key={index}>
								<span className='amount'>{NumberUtils.formatNumber(item.get('amount'))}</span><span className='currency'>{item.get('currency')}</span>
								-
								<span className='amount'>{formatShare(item.get('sharePct'))}</span><span className='currency'>%</span>
								-
								<span className='name'>{item.get('partyName')} <span className='id'>({item.get('partyId')})</span></span>
							</DetailItem>
						);
					});
				}
			}
		},
		withNewEntityButton: false,
		defaultColumnWidths: {
			'type': '200px',
			'distribution_period_id': '210px',
			admin_comments: '120px',
		},
		columnAlign: {
			admin_comments: 'center'
		},
		columnFilters: {
			'distribution_period_id': {
				type: 'lookup',
				lookup: 'affirmationDistributionPeriod'
			},
			type: {
				type: 'lookup',
				lookup: 'affirmationAnomaly'
			},
			title: {
				type: 'text'
			},
			detail: {
				type: 'lookup',
				lookup: 'affirmationSubmissionParty',
				filterName: 'producer_id'
			},
			admin_comments: {
				type: 'lookup',
				lookup: 'ynBoolean',
				filterName: 'has_admin_comments'
			}
		}
	};
}

const formatShare = NumberUtils.getFixedDecimalFormatNumber(2);

function getAffirmationSubmissionItemType() {
	if (!affirmationSubmissionItemTypeLookup) {
		affirmationSubmissionItemTypeLookup = getLookup('affirmationSubmissionItemType');
	}
	return affirmationSubmissionItemTypeLookup;
}

const ConflictDetail = styled.div`
	.status {
		text-align: center;
		margin-top: 4px;
		font-weight: 500;
		.RESOLVED {
			color: ${props => props.theme.okColor};

			.smile {
				font-weight: 18px;
			}
		}

		.PASSED_ON_TO_PRODUCERS {
			color: #0011A8;
		}
		.IGNORED {
			color: ${props => props.theme.errorColor};
		}
	}

	.buttons {
		text-align: center;
		.simpleButton {
			border-radius: 6px;
			padding: 1px 6px;
			margin-right: 16px;
			font-weight: 500;
			cursor: pointer;
			border: 1px solid;
			margin-top: 4px;
			display: inline-block;
			&:hover {
				text-decoration: underline;
			}
			&.positive {
				color: ${props => props.theme.okColor};
			}
			&.negative {
				color: ${props => props.theme.errorColor};
			}
		}
	}
`;

function getConflictCustomResultProps(module) {
	return {
		cellRendererMap: {
			type: (cell, row) => {
				return cell + ' - ' + getPhrase(getAffirmationSubmissionItemType().getText(cell));
			},
			title: (cell, row) => {
				const productionYear = row.get('production_year');
				return (
					<Title>
						{cell} <span className='year'>({productionYear})</span>
					</Title>
				);
			},
			total_share_pct: (cell, row) => {
				return cell + '%';
			},
			status: (cell, row) => {
				if (!cell) {
					return '';
				}
				const isResolved = row.get('is_resolved');
				const isPublic = row.get('is_public');
				return (
					<ConflictDetail>
						<div className='status'>
							{
								isResolved === 'Y' ? (
									<div className='RESOLVED'><span className='smile'>&#128077;</span> {getPhrase('resolved')}</div>
								) : isPublic === 'Y' ? (
									<div className='PASSED_TO_PRODUCERS'>{getPhrase('passedToProducers')}</div>
								) : isPublic === 'X' ? (
									<div className='WAITING_FOR_YOUR_DECISION'>{getPhrase('waitingForYourDecision')}</div>
								) : isPublic === 'N' ? (
									<div className='IGNORED'>{getPhrase('ignored')}</div>
								) : null
							}
						</div>
						<div className='buttons'>
							{
								isResolved == 'N' && (isPublic === 'X' || isPublic === 'N') && (
									<span
										className='simpleButton positive'
										onMouseDown={async e => {
											e.preventDefault();
											const res = await webapi.execute('/api/proc/api_affirmations/setConflictIsPublic', {
												conflictId: row.get('id'),
												isPublic: 'Y'
											});
											if (res === REPORTED_EXCEPTION) {
												return;
											}
											module.setConflictIsPublic(row.get('id'), 'Y');
										}}
									>{getPhrase('passToProducers')}</span>
								)
							}
							{
								isResolved == 'N' && (isPublic === 'X' || isPublic === 'Y') && (
									<span
										className='simpleButton negative'
										onMouseDown={async e => {
											e.preventDefault();
											const res = await webapi.execute('/api/proc/api_affirmations/setConflictIsPublic', {
												conflictId: row.get('id'),
												isPublic: 'N'
											});
											if (res === REPORTED_EXCEPTION) {
												return;
											}
											module.setConflictIsPublic(row.get('id'), 'N');
										}}
									>{getPhrase('ignore')}</span>
								)
							}
						</div>
					</ConflictDetail>
				);
			},
			admin_comments: (cell, row) => {
				return (
					<Bubble
						value={row.get('admin_comments')}
						onMouseDown={async () => {
							const value = await showMessageBox(getFormItemLabel('adminComments'), {
								type: 'input',
								multiline: true,
								optional: true,
								input: row.get('admin_comments')
							});
							if (value === null) {
								return;
							}
							const res = await webapi.execute('/api/proc/api_affirmations/setConflictAdminComments', {
								id: row.get('id'),
								adminComments: value
							});
							if (res === REPORTED_EXCEPTION) {
								return;
							}
							module.setConflictAdminComments(row.get('id'), value);
						}}
						text={getPhrase('comment')}
					/>
				);
			},
			producers: (cell, row) => {
				if (!cell) {
					return '';
				}
				const isResolved = row.get('is_resolved');
				const isPublic = row.get('is_public');
				return (
					<ConflictDetail>
						{
							cell.map((item, index) => {
								return (
									<DetailItem key={index}>
										<span className='share'>{formatShare(item.get('sharePct'))}%</span>
										-
										<span className='name'>{item.get('partyName')} <span className='id'>({item.get('partyId')})</span></span>
									</DetailItem>
								);
							})
						}
					</ConflictDetail>
				);
			}
		},
		withNewEntityButton: false,
		defaultColumnWidths: {
			'total_share_pct': '140px',
			'type': '160px',
			'distribution_period_id': '210px',
			status: '260px',
			admin_comments: '120px'
		},
		columnAlign: {
			total_share_pct: 'right',
			admin_comments: 'center',
		},
		columnFilters: {
			'distribution_period_id': {
				type: 'lookup',
				lookup: 'affirmationDistributionPeriod'
			},
			total_share_pct: {
				type: 'number',
				inputSize: 3
			},
			type: {
				type: 'lookup',
				lookup: 'affirmationSubmissionItemType'
			},
			title: {
				type: 'text'
			},
			status: {
				type: 'lookup',
				lookup: 'affirmationConflictStatus'
			},
			producers: {
				type: 'lookup',
				lookup: 'affirmationSubmissionParty',
				filterName: 'producer_id'
			},
			admin_comments: {
				type: 'lookup',
				lookup: 'ynBoolean',
				filterName: 'has_admin_comments'
			}
		}
	};
}


const tabs = Immutable.fromJS([{
	id: 'submissionList',
	text: () => getPhrase('submissionList')
}, {
	id: 'anomalies',
	text: () => getPhrase('anomalies')
}, {
	id: 'conflicts',
	text: () => getPhrase('conflicts')
}, {
	id: 'producerSummary',
	text: () => getPhrase('producerSummary')
}, {
	id: 'currencies',
	text: () => getPhrase('currencies')
}]);


AffirmationSubmissionAdminModule.contextType = GlobalContext;


export default withGlobalContext(AffirmationSubmissionAdminModule);
